<template>
    <div class="row mb-1">
        <div class="col-12">
            <div class="card mb-1">
                <div class="card-body">
                    <form @submit.prevent="onSubmit">
                        <form-errors :errors="formErrors"/>
                        <div class="form-row">
                            <div class="col-12 col-sm-6">
                                <form-input label="Phone Number" type="phone" v-model="formData.phone_home" :errors="errors.phone_home" />
                            </div>
                        </div>
                        <p class="text-muted mb-0">
                            To correct your name, date of birth, or SSN, contact your manager.
                        </p>
                        <portal to="identity-edit-modal-footer">
                            <button-row stacked>
                                <button type="button" @click.prevent="onPrev()" class="btn btn-outline-primary">Cancel</button>
                                <button type="button" @click.prevent="onSubmit()" class="btn btn-primary">Save</button>
                            </button-row>
                        </portal>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ButtonRow from '@/components/ButtonRow'
import api from '@/api'

export default {
    mixins: [FormMixin],
    components: {ButtonRow, },
    props: ['employee', 'employeeUpdate', 'prev'],
    watch: {
        employee() {
            this.reset()
        },
        employeeUpdate() {
            this.reset()
        }
    },
    computed: {},
    data() {
        const data = {
            formData: this.makeFormData(),
            formRules: {
                phone_home: {presence: {allowEmpty: false}, ten_digit_phone: true},
            },
            pollInterval: null,
            formLabels: {
                phone_home: 'Phone Number',
            },
        }
        return data
    },
    unmounted() {
        if (this.pollInterval) {
            clearInterval(this.pollInterval)
        }
    },
    methods: {
        makeFormData() {
            let source = this.employeeUpdate ? this.employeeUpdate : this.employee
            // Name, suffix and DOB are deliberately absent: employees do not edit
            // their own legal identity here, a manager changes it in Payroll. The
            // action name stays 'edit-identity' so that clients still running an
            // older bundle keep working (the server ignores the extra fields they
            // send). See api.forms.EmployeeUpdateIdentityForm.
            let formData = {
                action: 'edit-identity',
                phone_home: source.phone_home,
            }
            return formData
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }
            this.$store.dispatch('START_LOADING')
            if (this.employeeUpdate) {
                this.patchEmployeeUpdate(this.employeeUpdate.id)
            } else {
                // If employeeUpdate wasn't passed in, that means we need to create one first before we patch it with form data
                api.post(`/me/ess/companies/${this.employee.company_id}/updates`, {}).then((resp) => {
                    this.patchEmployeeUpdate(resp['id'])
                }).catch((errors) => {
                    this.errors = errors
                    this.formErrors = errors.__all__
                    this.onError()
                    this.$store.dispatch('STOP_LOADING')
                })
            }
        },
        onPrev() {
            this.$emit('prev')
        },
        patchEmployeeUpdate(employeeUpdateId) {
            this.$store.dispatch('START_LOADING')
            api.patch(`/me/ess/companies/${this.employee.company_id}/updates/${employeeUpdateId}`, this.getFormData()).then((resp) => {
                // poll every 2 seconds to see the task status
                this.pollInterval = setInterval(() => {this.pollEmployeeUpdate(employeeUpdateId)}, 2000)
            }).catch((errors) => {
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
                this.$store.dispatch('STOP_LOADING')
            })
        },
        pollEmployeeUpdate(employeeUpdateId) {
            api.get(`/me/ess/updates/${employeeUpdateId}/progress`).then((resp) => {
                if (resp['status'] == 'SUCCESS') {
                    clearInterval(this.pollInterval)
                    this.$emit('updated')
                    this.$store.dispatch('STOP_LOADING')
                } else if (resp['status'] == 'FAILURE') {
                    clearInterval(this.pollInterval)
                    this.$bus.showError(resp['error'])
                    this.$store.dispatch('STOP_LOADING')
                } else {
                    // do nothing, keep polling
                }
            })
        },
    }
}
</script>
